type Props = {
  currentPage: number;
  numberOfPages: number;
  prev: () => void;
  next: () => void;
  isLoading?: boolean;
};

const Pagination = ({ prev, next, currentPage, numberOfPages, isLoading = false }: Props) => {
  const isPrevDisabled = currentPage === 1 || isLoading;
  const isNextDisabled = currentPage >= numberOfPages || isLoading;

  const handlePrev = () => {
    if (!isPrevDisabled) {
      prev();
    }
  };

  const handleNext = () => {
    if (!isNextDisabled) {
      next();
    }
  };

  return (
    <div className="flex justify-center mt-4">
      <div className="inline-flex items-center gap-2 rounded border border-gray-300 bg-white px-3 py-1 text-sm shadow-sm">
        {/* Prev Button */}
        <button
          onClick={handlePrev}
          disabled={isPrevDisabled}
          className={`px-3 py-1 rounded border border-transparent transition-all ${
            isPrevDisabled 
              ? "opacity-30 cursor-not-allowed bg-gray-100 text-gray-400 pointer-events-none" 
              : "cursor-pointer hover:bg-gray-100 text-gray-700"
          }`}
        >
          Prev
        </button>

        {/* Current Page */}
        <span className="px-3 py-1 rounded bg-gray-100 text-gray-800 font-medium">{currentPage}</span>

        {/* Next Button */}
        <button
          onClick={handleNext}
          disabled={isNextDisabled}
          className={`px-3 py-1 rounded border border-transparent transition-all ${
            isNextDisabled 
              ? "opacity-30 cursor-not-allowed bg-gray-100 text-gray-400 pointer-events-none" 
              : "cursor-pointer hover:bg-gray-100 text-gray-700"
          }`}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default Pagination;
